import React from 'react';
import { CrescentMoon } from '../components/CrescentMoon';
import { GoldDivider } from '../components/GoldDivider';
import { CTAButton } from '../components/CTAButton';
import { ShieldCheck, Download, Clock, Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center px-4 py-10 z-10 animate-fade-in" data-id="element-108">
      <div className="max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-109">
        <CrescentMoon className="mb-8" data-id="element-110" />

        <p className="text-gold uppercase tracking-[4px] text-xs md:text-sm font-lato mb-6 font-semibold" data-id="element-111">
          For Women Who Are Done Waiting
        </p>

        <h1 className="font-playfair text-lunar-white text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6 text-glow-violet" data-id="element-112">
          Stop Chasing.
          <br data-id="element-113" />
          Start Attracting.
          <br data-id="element-114" />
          While You Sleep.
        </h1>

        <h2 className="text-lunar-lavender text-lg md:text-xl max-w-2xl mx-auto font-lato leading-relaxed mb-8" data-id="element-115">
          The 3-minute bedtime script that rewires your subconscious to
          magnetically attract the man who truly sees you — no dating apps, no
          mind games, no waiting.
        </h2>

        <GoldDivider data-id="element-116" />

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-lunar-lavender text-sm mb-10 max-w-2xl" data-id="element-117">
          <span className="flex items-center" data-id="element-118">
            <Star className="w-3 h-3 text-gold mr-1" data-id="element-119" /> Used by 4,800+ women
          </span>
          <span className="hidden md:inline text-gold" data-id="element-120">✦</span>
          <span className="flex items-center" data-id="element-121">
            <Download className="w-3 h-3 text-gold mr-1" data-id="element-122" /> Instant Digital
            Access
          </span>
          <span className="hidden md:inline text-gold" data-id="element-123">✦</span>
          <span className="flex items-center" data-id="element-124">
            <Clock className="w-3 h-3 text-gold mr-1" data-id="element-125" /> Works the first night
          </span>
          <span className="hidden md:inline text-gold" data-id="element-126">✦</span>
          <span className="flex items-center text-gold font-semibold" data-id="element-127">
            Only $6.37
          </span>
        </div>

        <div className="w-full max-w-md mx-auto flex flex-col items-center" data-id="element-128">
          <CTAButton size="normal" className="mb-6" onClick={() => {
          document.getElementById('midnight-magnet')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-129">
            ✨ YES, I WANT MY SCRIPT — GET INSTANT ACCESS FOR $6.37
          </CTAButton>

          <div className="bg-green-900/20 border border-green-500/30 rounded-lg p-3 w-full" data-id="element-130">
            <p className="text-green-400 text-xs md:text-sm font-semibold flex items-center justify-center flex-wrap gap-2" data-id="element-131">
              <ShieldCheck className="w-4 h-4" data-id="element-132" /> Bank-Level Security · Instant
              Download · 100% Satisfaction Guaranteed
            </p>
          </div>
        </div>
      </div>
    </section>;
}